export default function ServiceTwoIcon({ name }) {
  const paths = {
    search: (
      <>
        <circle cx="11" cy="11" r="6.5" />
        <path d="m16 16 4 4" />
      </>
    ),
    close: <path d="m7 7 10 10M17 7 7 17" />,
    check: <path d="m6.5 12.5 3.3 3.3 7.7-8" />,
    arrow: <path d="m9 6 6 6-6 6" />,
    edit: (
      <>
        <path d="m14.5 5.5 4 4L9 19H5v-4Z" />
        <path d="m12.5 7.5 4 4" />
      </>
    ),
    trash: (
      <>
        <path d="M5 7h14M9 7V4h6v3M7 7l1 13h8l1-13" />
        <path d="M10 11v5M14 11v5" />
      </>
    ),
    info: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v6M12 7.5v.5" />
      </>
    ),
    car: (
      <>
        <path d="m5 16-1-1v-4l2-5h12l2 5v4l-1 1" />
        <path d="M6 16v2M18 16v2M4 12h16M7 13h.01M17 13h.01" />
      </>
    ),
    warning: (
      <>
        <path d="M12 3 2.8 20h18.4Z" />
        <path d="M12 9v4M12 16.5v.2" />
      </>
    ),
    service: (
      <path d="M14 6a4 4 0 0 0-5 5L3.5 16.5a2.1 2.1 0 0 0 3 3L12 14a4 4 0 0 0 5-5l-2.5 2.5-2-2Z" />
    ),
    eye: (
      <>
        <path d="M2.5 12s3.5-5 9.5-5 9.5 5 9.5 5-3.5 5-9.5 5-9.5-5-9.5-5Z" />
        <circle cx="12" cy="12" r="2.4" />
      </>
    ),
    replace: (
      <>
        <path d="M4 7h12l-2.5-2.5M20 17H8l2.5 2.5" />
        <path d="m16 7 2.5 2.5M8 17l-2.5-2.5" />
      </>
    ),
    oil: <path d="M12 3S6 10 6 15a6 6 0 0 0 12 0c0-5-6-12-6-12Z" />,
    belt: (
      <>
        <circle cx="8" cy="12" r="4" />
        <circle cx="17" cy="12" r="2.5" />
        <path d="M8 8h9M8 16h9" />
      </>
    ),
    gearbox: (
      <>
        <circle cx="12" cy="12" r="3" />
        <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1" />
      </>
    ),
    spark: <path d="m13 2-7 11h6l-1 9 7-12h-6Z" />,
    fluid: (
      <>
        <path d="M8 4h8v3l2 3v9H6v-9l2-3Z" />
        <path d="M8 14h8" />
      </>
    ),
    brake: (
      <>
        <circle cx="12" cy="12" r="7" />
        <circle cx="12" cy="12" r="2.5" />
        <path d="M5 7 2.5 9v6L5 17" />
      </>
    ),
    clutch: (
      <>
        <circle cx="12" cy="12" r="8" />
        <circle cx="12" cy="12" r="3" />
        <path d="M12 4v3M12 17v3M4 12h3M17 12h3" />
      </>
    ),
    tire: (
      <>
        <circle cx="12" cy="12" r="8" />
        <circle cx="12" cy="12" r="4" />
        <path d="M9 4.6 10 8M15 4.6 14 8M9 19.4l1-3.4M15 19.4 14 16" />
      </>
    ),
    inspection: (
      <>
        <path d="M6 3h12v18H6Z" />
        <path d="M9 8h6M9 12h6M9 16h3" />
        <path d="m14 16 1.5 1.5L19 14" />
      </>
    ),
    insurance: (
      <>
        <path d="M12 3 5 6v5c0 5 3 8 7 10 4-2 7-5 7-10V6Z" />
        <path d="m9 12 2 2 4-4" />
      </>
    ),
    battery: (
      <>
        <path d="M5 7h14v12H5Z" />
        <path d="M9 4v3M15 4v3M8 13h3M9.5 11.5v3M14 13h3" />
      </>
    ),
    wash: (
      <>
        <path d="M5 15h14l-1.5-5h-11Z" />
        <path d="M7 15v3M17 15v3M5 12H3M19 12h2M8 4l-1 2M12 3v3M16 4l1 2" />
      </>
    ),
    window: (
      <>
        <path d="M5 5h14l2 14H3Z" />
        <path d="m7 8 10 8M11 7l7 6M6 13l5 4" />
      </>
    ),
  };
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      {paths[name] || paths.service}
    </svg>
  );
}
